import styled from "styled-components";
import device from "src/constants/media";
import { typography, colors } from "src/theme";

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 70vh;
  padding-bottom: 50px;
`;
export const Waves = styled.div`
  position: absolute;
  width: 100%;
  height: 960px;
  top: 330px;
  background-image: url("/background/WavesUp.svg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  @media ${device.laptopL} {
    max-width: 872px;
    margin: 0 auto;
  }
`;
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px 48px;
  @media ${device.mobileL} {
    padding: 16px 44px 48px;
  }
  @media ${device.laptop} {
    padding: 32px 110px 64px;
  }
  @media ${device.laptopS} {
    padding: 32px 248px 64px;
  }
  @media ${device.laptopL} {
    padding: 32px 0 64px;
  }
`;
export const Text = styled.p`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: ${colors.mainLight};
  @media ${device.laptop} {
    margin-top: 51px;
  }
`;
export const Title = styled.p`
  padding: 12px 0;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 44px;
  color: ${colors.white};
  @media ${device.laptop} {
    padding: 24px 0;
    font-size: 80px;
    line-height: 88px;
    letter-spacing: 0.01em;
  }
`;
export const SubTitle = styled.p`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.white};
  @media ${device.laptop} {
    font-size: 24px;
    line-height: 32px;
  }
`;
/* export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 260px;
  height: 418px;
  margin: 0 auto 80px;
  padding: 24px;
  border-radius: 8px;
  background: ${colors.white};
  @media ${device.tablet} {
    padding: 0 110px;
    width: 660px;
    height: 574px;
    margin: 0 auto 126px;
  }
`
export const Calendar = styled.div`
  width: 145px;
  height: 108px;
  margin-bottom: 12px;
  @media ${device.tablet} {
    width: 220px;
    height: 170px;
    margin: 24px 0 12px;
  }
`
export const ContainerTitle = styled.p`
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 24px;
  color: ${colors.darkGrey};
  @media ${device.tablet} {
    font-weight: 600;
    font-size: 34px;
    line-height: 36px;
  }
`
export const ContainerText = styled.p`
  margin-top: 8px;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: ${colors.darkGrey};
  @media ${device.tablet} {
    margin-top: 12px;
    font-size: 18px;
    line-height: 24px;
  }
`
export const ContainerInput = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 36px;
  @media ${device.tablet} {
    margin-top: 48px;
  }
`
export const InputLabel = styled.p`
  margin-bottom: 12px;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: start;
  color: ${colors.darkGrey};
  @media ${device.tablet} {
    margin-bottom: 12px;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
  }
` */
export const Container = styled.iframe`
  width: 100%;
  height: 870px;
  border: none;
  margin: 0 auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  &::-webkit-scrollbar {
    display: none; /* WebKit */
  }
  @media ${device.tablet} {
    width: 100%;
    height: 870px;
    border: none;
    margin: 0 auto;
  }
`;
